import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Star, Eye } from 'lucide-react';
import { FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-[#273e82] text-white mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Sobre */}
          <div>
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: 'Manrope', color: '#fef000' }}>
              Central de Ferragens
            </h3>
            <p className="text-slate-300 leading-relaxed">
              Grande variedade.<br />
              São mais de 15 mil itens em materiais elétricos, hidráulicos, ferragens e ferramentas.
            </p>
          </div>

          {/* Endereço e Contato */}
          <div>
            <h4 className="font-bold mb-4" style={{ fontFamily: 'Manrope' }}>Onde Estamos</h4>
            <div className="space-y-3">
              <a
                href="https://www.google.com/maps/search/?api=1&query=R.+João+Pessoa,+245+-+Vila+Luiza,+Canela+-+RS,+95680-000"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-2 text-slate-300 hover:text-[#fef000] transition-colors"
              >
                <MapPin size={20} className="flex-shrink-0 mt-0.5" />
                <span>
                  R. João Pessoa, 245<br />
                  Centro, Canela - RS<br />
                  95686-070
                </span>
              </a>

              <a
                href="https://wa.me/555432827737?text=Olá,%20vim%20pelo%20site%20da%20Central%20de%20Ferragens"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-slate-300 hover:text-[#fef000] transition-colors"
              >
                <FaWhatsapp size={20} />
                <span>(54) 3282-7737</span>
              </a>
            </div>
          </div>

          {/* Links Rápidos */}
          <div>
            <h4 className="font-bold mb-4" style={{ fontFamily: 'Manrope' }}>Links Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-300 hover:text-[#fef000] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/carrinho" className="text-slate-300 hover:text-[#fef000] transition-colors">
                  Carrinho
                </Link>
              </li>
            </ul>
          </div>

          {/* Avaliações e Street View */}
          <div>
            <h4 className="font-bold mb-4" style={{ fontFamily: 'Manrope' }}>Conheça Nossa Loja</h4>
            <div className="space-y-3">
              <a
                href="https://www.google.com/search?sca_esv=ac828fb99d817095&rlz=1C1GCEA_enBR1202BR1202&sxsrf=ANbL-n6YfFlwotjSvyNA_AkbCm4jnnNUCg:1772506752219&si=AL3DRZHrmvnFAVQPOO2Bzhf8AX9KZZ6raUI_dT7DG_z0kV2_x7R5LjQj5KBM-vu9MXHNLR28bICaoWdePV1ucfIwJBsRxlwcVSHUUrDTrdUOaH7L_on-YuA-gvLwBJ3zU9cO_3hXGxyuqh4dzs2r61GjERhjuHIX4A%3D%3D&q=Central+Ferragens+Coment%C3%A1rios&sa=X&ved=2ahUKEwiZys-a3oKTAxVRFLkGHZi6EZUQ0bkNegQIKRAF&biw=1536&bih=730&dpr=1.25#lrd=0x95192db1c2b26645:0x40d60733af788466,3"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-slate-300 hover:text-[#fef000] transition-colors"
              >
                <Star size={20} />
                <span>Avalie-nos no Google</span>
              </a>

              <a
                href="https://www.google.com/local/place/fid/0x95192db1c2b26645:0x40d60733af788466/photosphere?iu=https://streetviewpixels-pa.googleapis.com/v1/thumbnail?panoid%3D9_C8ZnNhIfGNw9XuvjhT8A%26cb_client%3Dsearch.gws-prod.gps%26yaw%3D342.22565%26pitch%3D0%26thumbfov%3D100%26w%3D0%26h%3D0&ik=CAISFjlfQzhabk5oSWZHTnc5WHV2amhUOEE%3D&sa=X&sqi=2&ved=2ahUKEwiZys-a3oKTAxVRFLkGHZi6EZUQpx96BAg3EBI"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-slate-300 hover:text-[#fef000] transition-colors"
              >
                <Eye size={20} />
                <span>Ver a loja no Street View</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-600 mt-8 pt-8 text-center text-slate-400">
          <p>&copy; 2026 Central de Ferragens. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;